import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toggleWorkoutDay } from "../services/firebase-weight-service";
import { addGuestWorkout } from "../services/guestStorage";

export const useWorkoutMutations = (uid) => {
  const queryClient = useQueryClient();
  const isGuest = !uid || uid === "guest";

  return useMutation({
    mutationFn: ({ day, currentMonth, isDelete }) =>
      isGuest
        ? addGuestWorkout({ day: day.toISOString(), month: currentMonth.toISOString(), isDelete })
        : toggleWorkoutDay(uid, day, currentMonth, isDelete),

    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: [
          "workouts",
          uid,
          variables.currentMonth.getMonth(),
          variables.currentMonth.getFullYear(),
        ],
      });
    },
  });
};
